TweenMax = require 'tween'
TweenBezier = require 'tweenBezier'
imageManager = require 'imageManager'
eventManager = require 'eventManager'
currencyManager = require 'currencyManager'
ScratchArea = require 'scratch-area'
gameModel = require 'gameModel'
imageModel = require 'imageModel'
log = require 'loglevel'

class SingleScratchView extends PIXI.Container

  name: 'SingleScratchView'
  el: '#canvas-container'
  dpi: __dpi
  gameOver: false
  prizes: []
  tweens: []
  pulseSpeed: 10
  lostAlpha: 0.4
  hintDelay: 5000
  prizesStartingZ: 1
  numberOfMatchesToWin: 3
  scratchedWinningCount: 0
  padding: 20
  initSin: 0
  pulseSpeed: 0.05

  # radians per frame
  startRotationSpeed: 0.03

  colorCodes: [
    "255-43-6" #red
    "255-49-167" #pink
    "125-71-167" #purple
    "74-35-251" #blue
    "255-213-40" #orange
    "0-252-255" #cyan
    "0-251-128" #mint
    "19-210-39" #green
    "254-253-50" #yellow
    "243-78-255" #violet
  ]

  #----------------------------------------------

  constructor: (@htmlWidth, @htmlHeight, y)->
    log.info @name, 'constructor', @htmlWidth, @htmlHeight
    super()
    @y = y

  #----------------------------------------------

  initSetup: (callback) ->
    log.info @name, 'initSetup'

    imageManager.loadImage imageModel.unscratchedImage, (@unscratchedImage) =>

      @w = @unscratchedImage.width/__dpi
      @h = @unscratchedImage.height/__dpi
      @x = (gameModel.gameWidth - @w)/2

      @addBackground @w, @h, @x, =>
        @addScratchCanvas(@w, @h, false)
        callback(@x, @y, @w, @h)

  #----------------------------------------------

  setupWithTicket: (betModel, callback) ->

    @reset()

    @betModel = betModel
    prizeMatrix = @betModel.getMatrix()

    isWinner = @betModel.isWin()
    winningPrizeId = @betModel.getWinIndex()

    if gameModel.hasMultiplier
      possibleWinIndex = @betModel.getWinPossIndex()

      # HACK to fix PP WinPossIndex = 0 error
      if possibleWinIndex <= 0
        if not betModel.isWin()
          console.log('PPB: index was 0')
          possibleWinIndex = gameModel.getRandomWin()
        else
          console.error("PPB: WinPossIndex issue, please report")
          return

      ids = gameModel.getPrizeForId(possibleWinIndex)
      multiplierId = ids[1]

    @addScratchCanvas(@w, @h, false)

    @loadAllImages prizeMatrix, multiplierId, winningPrizeId, =>

      @addPrizes prizeMatrix, winningPrizeId
      @addMultiplier(multiplierId, isWinner,winningPrizeId) if gameModel.hasMultiplier
      @scratchArea.setupMasks @prizes

      callback()

  #----------------------------------------------

  allowScratching: (enabled = true) ->
    @scratchArea.allowScratching = enabled
    @hasUserDismissedHint = false
    @showHint(@hintDelay)

  #----------------------------------------------

  loadAllImages: (matrix,multiplierId,winningPrizeId,callback) ->

    imagesToLoad = []

    for prizeId in matrix
      prizeImageId = gameModel.getPrizeImgForId prizeId
      prizeImg = imageModel.getUrlForPrize prizeImageId
      imagesToLoad.push prizeImg

    imagesToLoad.push imageModel.scratchedImage

    if gameModel.hasMultiplier
      imagesToLoad.push imageModel.getUrlForMultiplier multiplierId

    if gameModel.hasPrizeAnimations and winningPrizeId
      winningPrizeImageId = gameModel.getPrizeImgForId winningPrizeId
      json = imageModel.getWinAnimationForPrizeid winningPrizeImageId
      imagesToLoad.push json

    if gameModel.hasMultiAnimations and winningPrizeId
      json = imageModel.getMultiAnimationForPrizeid multiplierId
      imagesToLoad.push json


    imageManager.loadAssets imagesToLoad, =>
      callback()

  #----------------------------------------------

  reset:  ->

    eventManager.stopListeningTo 'frame', @updateCallback

    if @prizes?
      i = @prizes.length
      while i--
        prize = @prizes[i]
        prize.removeChildren()
        @removeChild prize
        @prizes.splice(i, 1)

    @removeChild @multiplierContainer

    @prizes = null
    @betModel = null
    @multiplierContainer = null

    delete @prizes
    delete @betModel
    delete @multiplierContainer

    @scratchedWinningCount = 0
    @gameOver = false

    if @scratchArea?
      @scratchArea.reset()
      # @removeChild @scratchArea
      # @scratchArea.removeChildren()
      # @scratchArea = null
      # delete @scratchArea

  #----------------------------------------------

  cover: ->
    if @scratchArea?
      @scratchArea.reset()

  #----------------------------------------------

  addScratchCanvas: (w,h,allowScratching) ->

    if @scratchArea?
      @scratchArea.reset()
      # @scratchArea.allowScratching = allowScratching
      @scratchArea.bringToFront()
      return

    @scratchArea = new ScratchArea()
    @scratchArea.game = @
    @scratchArea.allowScratching = allowScratching
    @scratchArea.render(@unscratchedImage, w, h, 0, @y)
    @addChild @scratchArea

  #----------------------------------------------

  addBackground: (w,h,p,callback) ->
    prizeUrl = imageModel.scratchedImage

    imageManager.loadAsset prizeUrl, =>

      @tile = new PIXI.Sprite.fromImage(prizeUrl)
      @tile.width = w
      @tile.height = h

      @addChild @tile
      callback()

  #----------------------------------------------

  addPrizes: (matrix, winningPrizeId, callback) ->
    return unless matrix?

    for prizeId, i in matrix

      point = gameModel.positions.points[i]

      return unless point?

      x = point.x * @width
      y = point.y * @height
      cc = @colorCodes[i]

      @addAPrize x, y, prizeId, winningPrizeId, cc, i

  #----------------------------------------------

  addAPrize: (x,y,prizeId,winningPrizeId,colorCode,index) ->

    isWinner = Number(prizeId) is Number(winningPrizeId)

    container = new PIXI.Container()
    container._name = 'prize-container'
    container.prizeId = prizeId
    container.colorCode = colorCode
    container.isWinner = isWinner
    container.prizeIndex = index
    container.winningPrizeId = winningPrizeId

    prizeImageId = gameModel.getPrizeImgForId prizeId
    prizeYOffet = gameModel.getPrizeYOffetForId prizeId

    prizeFilename = gameModel.images.prizes[prizeImageId]
    prizeImg = imageModel.getUrlForPrize prizeImageId
    prize = new PIXI.Sprite.fromImage prizeImg
    prize.tag = 'prize'
    prize.scale.set gameModel.prizeScale
    prize.anchor.set(0.5)
    prize.y = prizeYOffet

    container.addChild prize

    if isWinner and not gameModel.hasPrizeAnimations
      url = imageModel.starImage
      star = new PIXI.Sprite.fromImage url
      star.visible = true
      star.alpha = 0
      star.anchor.set(0.5)
      star.tag = 'star'
      star.scale.set(0.75)
      container.addChildAt star, 0

    style = gameModel.styles.prize
    if gameModel.isMaxPrize prizeImageId
      style = gameModel.styles.maxPrize

    numberAmount = gameModel.getPrizeAmount prizeId

    text = currencyManager.localize numberAmount, true, false

    amount = new PIXI.Text text, style
    container.addChild amount
    amount.sizeToFit(80,false)
    amount.centerAtPoint(0,gameModel.prizeTextY)
    amount.clarify()

    container.position.x = Math.round(x)
    container.position.y = Math.round(y)

    @prizes.push container
    @addChildAt container, @prizesStartingZ

    container

  #----------------------------------------------

  addMultiplier: (multiplierId, isWinner,winningPrizeId) ->

    @multiplierContainer = new PIXI.Container()
    @multiplierContainer._name = 'multiplier-container'
    @multiplierContainer.multiplierId = multiplierId
    @multiplierContainer.isWinner = isWinner
    @multiplierContainer.winningPrizeId = winningPrizeId
    # @multiplierContainer.anchor.set(0.5,0.5)

    if isWinner and not gameModel.hasPrizeAnimations
      url = imageModel.starImage
      star = new PIXI.Sprite.fromImage url
      star.visible = true
      star.alpha = 0.1
      star.anchor.set(0.5)
      star.tag = 'star'
      star.scale.set(0.75)
      @multiplierContainer.addChildAt star, 0

    prizeImg = imageModel.getUrlForMultiplier multiplierId
    prize = new PIXI.Sprite.fromImage prizeImg
    prize.tag = 'prize'
    prize.scale.set gameModel.prizeScale
    prize.anchor.set 0.5

    @multiplierContainer.addChild prize

    x = gameModel.positions.multiplier.x * @width
    y = gameModel.positions.multiplier.y * @height

    @multiplierContainer.position.x = x
    @multiplierContainer.position.y = y
    @addChildAt @multiplierContainer, @prizesStartingZ

  #----------------------------------------------

  prizeScratched: (colorCode) ->

    check = false

    for prize in @prizes

      if prize.colorCode is colorCode and prize.isWinner
        @scratchedWinningCount++
        check = true
        # log.info 'winning prize scratched', @scratchedWinningCount
        break

      if prize.colorCode is colorCode
        check = true
        # log.info 'prize scratched', prize.colorCode,colorCode
        break

    if @scratchedWinningCount is @numberOfMatchesToWin
      @scratchAll()

  #----------------------------------------------

  beganScratching: ->
    @hideHint()
    @updateCallback = eventManager.listenTo 'frame', =>
      @scratchArea.texture.update()

  #----------------------------------------------

  allScratched: () ->

    return if @gameOver
    @gameOver = true

    # return

    @scratchArea.texture.update()
    eventManager.stopListeningTo 'frame', @updateCallback
    @updateCallback = null

    if gameModel.hasPrizeAnimations
      prizes = @animateMovies()
    else
      prizes = @animateStars()

    @parent.endGame(prizes)

  #----------------------------------------------

  animateStars: ->

    winningPrizes = []

    i = @prizes.length
    while i--

      prize = @prizes[i]
      if prize.isWinner
        star = prize.getByTag 'star'
        star.visible = true
        winningPrizes.push prize

      else
        TweenMax.to(prize, 300/1000, {alpha: 0.5})

    if gameModel.hasMultiplier

      if winningPrizes.length > 0
        star = @multiplierContainer.getByTag 'star'
        star.visible = true
        winningPrizes.push @multiplierContainer
      else
        TweenMax.to(@multiplierContainer, 300/1000, {alpha: 0.5})

    @updateCallback = eventManager.listenTo 'frame', =>

      sinus = (Math.sin(@initSin) * 0.08) + gameModel.prizeScale
      @initSin += 0.12

      for prizeContainer, i in winningPrizes
        prize = prizeContainer.getByTag 'prize'
        star = prizeContainer.getByTag 'star'
        star.rotation += @startRotationSpeed

        if star.visible
          alpha = star.alpha + 0.03
          alpha = 1 if alpha > 1
          star.alpha = alpha

          prize.scale.x = sinus
          prize.scale.y = sinus

    winningPrizes

  #----------------------------------------------

  animateMovies: ->
    winningPrizes = []

    i = @prizes.length
    while i--
      prizeContainer = @prizes[i]
      if prizeContainer.isWinner

        prize = prizeContainer.getByTag('prize')
        prizeId = prizeContainer.prizeId
        prizeYOffet = gameModel.getPrizeYOffetForId prizeId

        animatedPrize = @getWinAnimation(prizeId)
        animatedPrize.animationSpeed = 0.168
        animatedPrize.anchor.set 0.5
        animatedPrize.y = prizeYOffet

        prize.visible = false
        prizeContainer.addChildAt animatedPrize, 1
        animatedPrize.play()

        winningPrizes.push prizeContainer

      else
        TweenMax.to(prizeContainer, 1, {alpha: 0.5})

    if gameModel.hasMultiplier

      if @multiplierContainer.isWinner

        prize = @multiplierContainer.getByTag('prize')
        multiplierId = @multiplierContainer.multiplierId

        animatedPrize = @getMultiWinAnimation(multiplierId)
        animatedPrize.animationSpeed = 0.168
        animatedPrize.anchor.set 0.5
        animatedPrize.y = prizeYOffet

        prize.visible = false
        @multiplierContainer.addChildAt animatedPrize, 1
        animatedPrize.play()

        winningPrizes.push @multiplierContainer
      else
        TweenMax.to(@multiplierContainer, 1, {alpha: 0.5})

    winningPrizes

  #----------------------------------------------

  getWinAnimation: (prizeId) ->
    prizeImageId = gameModel.getPrizeImgForId prizeId
    textureArray = imageManager.makeTexturesFromName 'prize-'+prizeImageId
    winner = new PIXI.extras.AnimatedSprite(textureArray,true)
    winner

  #----------------------------------------------

  getMultiWinAnimation: (multiplierId) ->
    textureArray = imageManager.makeTexturesFromName 'multi-'+multiplierId+'x'
    winner = new PIXI.extras.AnimatedSprite(textureArray,true)
    winner

  #----------------------------------------------

  scratchAll: (cb) ->
    eventManager.trigger 'will-reveal-all'
    @scratchArea.clear true, =>
      @allScratched()
      cb() if cb?

  #----------------------------------------------

  showHint: (delay) ->

    if @hasUserDismissedHint
      @hideHint()
      return

    unless @finger?
      url = imageModel.fingerImg
      @finger = new PIXI.Sprite.fromImage url
      # @finger.scale.set(0.5,0.5)

    @hintTimer = setTimeout( =>

      return @hideHint() if @hasUserDismissedHint

      @addChild @finger
      @finger.x = 120
      @finger.y = 140

      x = @finger.x
      speed = 1100
      offset = 50

      bezier =
        values: [{ x: x-offset }, { x: x+offset }, { x: x }]
        type: 'thru'
        curviness: 0
        timeResolution: 0

      to =
        bezier: bezier
        ease: Linear.easeNone

      @fingerAnimation = TweenMax.to(@finger, speed/1000, to)

      @showHint(3000)

    , delay)

  # -------------------------------------------

  hideHint: ->
    clearTimeout @hintTimer if @hintTimer?
    @removeChild @finger
    clearInterval @fingerInterval
    @fingerAnimation.kill() if @fingerAnimation?
    @fingerAnimation = null
    @hasUserDismissedHint = true

  # -------------------------------------------

module.exports = SingleScratchView


// WEBPACK FOOTER //
// ./coffee/view/single-scratch-view.coffee